import SocieteConfigNiveauxController from './societe.config.niveaux.controller';

export default {
    template: require('./societe.config.niveaux.tpl.html'),
    controller: SocieteConfigNiveauxController,
    bindings: {}
};
